import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import AddRsvpFormComponent from '../components/AddRsvpFormComponent';
import AddRsvpFormControlComponent from '../components/AddRsvpFormControlComponent';

import { fetchBuildingResidents } from '../../Resident/actionCreators';
import { refetchPMCorBuildingStaff } from '../../Staff/actionCreators';
import {
  addRsvpGuest,
  createRsvp,
  getEventData,
  getEventRsvpsForFilter,
} from '../actions';

import { formatResidentsForFilter, formatRsvpsForFilter } from '../utils';

import { GUESTS_ROLES } from '../constants';

import {
  getBuildingResidents,
  getBuildingStaff,
} from '../../Building/selectors';

const form = 'addRsvp';

const AddRsvpContainer = ({
  eventId,
  setIsModalOpen,
  queryParams,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((store) => store);
  const [value, setValue] = useState(GUESTS_ROLES.resident);

  const initialValues = {};
  const { events } = store;

  const buildingId = events?.event?.buildingId;
  const staff = useSelector((store) => getBuildingStaff(store, buildingId));
  const residents = useSelector((store) =>
    getBuildingResidents(store, buildingId),
  );

  const formValues = getFormValues(form)(store);
  const { rsvp, attendeeName } = formValues || {};

  const options =
    value === GUESTS_ROLES.nonresident
      ? formatRsvpsForFilter(events?.eventRsvpsForFilter)
      : value === GUESTS_ROLES.resident
      ? formatResidentsForFilter(residents)
      : formatResidentsForFilter(staff);

  const handleChange = (e) => setValue(e.target.value);
  const onLoad = () => getEventData(dispatch, eventId);
  const onSubmit = async () => {
    let response;
    if (value !== GUESTS_ROLES.nonresident) {
      response = await createRsvp(
        dispatch,
        { eventId, attendeeId: rsvp },
        queryParams,
      );
    } else {
      response = await addRsvpGuest(
        dispatch,
        rsvp,
        [{ attendeeName }],
        queryParams,
      );
    }

    if (response) setIsModalOpen(false);
  };

  useEffect(() => {
    if (value === GUESTS_ROLES.nonresident) {
      getEventRsvpsForFilter(dispatch, {
        disable_pagination: true,
        event_id: eventId,
      });
    }
    if (value === GUESTS_ROLES.resident && buildingId) {
      fetchBuildingResidents(dispatch, buildingId);
    }
    if (value === GUESTS_ROLES.staff && buildingId) {
      refetchPMCorBuildingStaff(dispatch, {
        match: { params: { buildingId } },
      });
    }
  }, [value, buildingId]);

  return (
    <>
      <AddRsvpFormControlComponent value={value} handleChange={handleChange} />
      <AddRsvpFormComponent
        onSubmit={onSubmit}
        initialValues={initialValues}
        radio={value}
        selectOptions={options}
        onLoad={onLoad}
        form={form}
        handleClose={handleClose}
      />
    </>
  );
};

AddRsvpContainer.propTypes = {
  eventId: PropTypes.string.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  queryParams: PropTypes.instanceOf(Object).isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddRsvpContainer;
